import CaretRight from '@/components/Icons/CaretRight';
import DiamondsFour from '@/components/Icons/DiamondsFour';
import React, { FC } from 'react';

import s from './ReferencedList.module.scss';

const ReferencedList: FC<{
  referencedList: { isReferencingExistingList: boolean; fieldLabel: string, subFieldLabel: string, fieldKey: string, subFieldKey : string};
  onClick?: () => void;
}> = ({ onClick, referencedList }) => (
  <div className={s.label} onClick={onClick}>
    <div className={s.labelBg}/>
    <DiamondsFour size={12} />
    Linked to {referencedList.fieldLabel}
    <CaretRight size={12} />
  </div>
);

export default ReferencedList;
